import EmptyList from '../fragments/EmptyList';

export default /* GraphQL */ `
    mutation CreateList($name: String!) {
        list: createList(name: $name, setSelected: true) {
            ...EmptyList
        }
    }
    ${EmptyList}
`;
